import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LocalizationService } from './service/localization.service';
// import { RotationHandlerComponent } from './component/rotation-handler/rotation-handler.component';
import { SpeechButtonComponent } from './component/atoms/speech-button/speech-button.component';
import { VoiceSearchPageComponent } from './page/voice-search-page/voice-search-page.component';
import { P01IntroPageComponent } from './page/p01-intro-page/p01-intro-page.component';
import { C01TvFrameComponent } from './component/c01-tv-frame/c01-tv-frame.component';
import { BrowseTitlesPageComponent } from './page/browse-titles-page/browse-titles-page.component';
import { S01NavigationComponent } from './component/s01-navigation/s01-navigation.component';
import { C02RemoteControlButtonsComponent } from './component/c02-remote-control-buttons/c02-remote-control-buttons.component';
import { A11yModule } from '@angular/cdk/a11y';
import { C03QuestionMarkModalComponent } from './component/c03-question-mark-modal/c03-question-mark-modal.component';
import { C04OpeningScreenComponent } from './component/c04-opening-screen/c04-opening-screen.component';
import { WatchlistPageComponent } from './page/watchlist-page/watchlist-page.component';
import { C05CompareModalComponent } from './component/c05-compare-modal/c05-compare-modal.component';
import { A02ComparisonButtonComponent } from './component/atoms/a02-comparison-button/a02-comparison-button.component';
import { C06EndScreenComponent } from './component/c06-end-screen/c06-end-screen.component';
import { RecommendationsPageComponent } from './page/recommendations-page/recommendations-page.component';
import { C07TvIntroScreenComponent } from './component/c07-tv-intro-screen/c07-tv-intro-screen.component';
import { C08BrowseTitlesSliderComponent } from './component/c08-browse-titles-slider/c08-browse-titles-slider.component';
import { c09VoiceIntroScreenComponent } from './component/c09-voice-intro-screen/c09-voice-intro-screen.component';
import { A03DisclaimerParagraphComponent } from './component/atoms/a03-disclaimer-paragraph/a03-disclaimer-paragraph.component';
import { A04PictureElementComponent } from './component/atoms/a04-picture-element/a04-picture-element.component';
import { A05CustomCtaComponent } from './component/atoms/a05-custom-cta/a05-custom-cta.component';
import { APP_BASE_HREF } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AssetPipe } from './pipe/asset-pipe';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    // Pages
    VoiceSearchPageComponent,
    P01IntroPageComponent,
    BrowseTitlesPageComponent,
    WatchlistPageComponent,
    RecommendationsPageComponent,
    // Components
    AppComponent,
    // RotationHandlerComponent,
    SpeechButtonComponent,
    A02ComparisonButtonComponent,
    S01NavigationComponent,
    C01TvFrameComponent,
    C02RemoteControlButtonsComponent,
    C03QuestionMarkModalComponent,
    C04OpeningScreenComponent,
    C05CompareModalComponent,
    C06EndScreenComponent,
    C07TvIntroScreenComponent,
    C08BrowseTitlesSliderComponent,
    c09VoiceIntroScreenComponent,
    A03DisclaimerParagraphComponent,
    A04PictureElementComponent,
    A05CustomCtaComponent,
    // Pipes
    AssetPipe,
  ],
  imports: [
    LottieModule.forRoot({ player: playerFactory }),
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    A11yModule,
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: environment.baseHref },
    LocalizationService,
    HttpClient,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
